/*Generated from the `:::slide{key="b74057f7-c390-481f-b1f4-1f28c61ca1db" slug="component-mnemonics"}` (simplified/001/003/凵.mdx), `:::slide{key="63691eaf-a7d9-4476-a040-b1a3764b2502" slug="han-hannah-hansel"}` (simplified/001/003/凵.mdx) directives, merged because they share one anchor. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "5",
      children: _jsx(html.p, {
        children: "Every Chinese character can be built up from strokes and simpler components.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "5",
      children: _jsx(html.p, {
        children: "In Haniverse, each character comes with a mnemonic containing all their components.",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "1",
      kind: "p",
      count: "5",
      children: _jsxs(html.p, {
        children: ["The next card's mnemonic introduces a man named ", _jsx(html.strong, {
          children: "Han",
          components: html
        }), "."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "1",
      kind: "p",
      count: "5",
      children: _jsxs(html.p, {
        children: ["You may also encounter ", _jsxs(html.em, {
          children: [_jsx(html.strong, {
            children: "Han",
            components: html
          }), "nah"]
        }), " (a woman), and ", _jsxs(html.em, {
          children: [_jsx(html.strong, {
            children: "Han",
            components: html
          }), "sel"]
        }), " (a kid)."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "4",
      section: "1",
      kind: "p",
      count: "5",
      children: _jsx(html.p, {
        children: "These names don't mean anything special. They just help make mnemonics more memorable.",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
